import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-checkout-layout',
  imports: [RouterOutlet],
  templateUrl: './checkout-layout.component.html',
  styleUrl: './checkout-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckoutLayoutComponent {}
